module.exports = require("core-js-pure/stable/json/stringify");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js-stable/json/stringify.js
// module id = 34
// module chunks = 0 1